import { Breadcrumbs } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ApplicationState } from '@xver/store';
import DialogBox from '@xver/components/Atoms/DialogBox/DialogBox';
import useBreadcrumbItems from '@xver/hooks/useBreadcrumbItems';
import usePageHeading from '@xver/hooks/usePageHeading';

import CouponEligibilityNotice from './components/CouponEligibilityNotice';
import CouponRedeemForm from './components/CouponRedeemForm';
import { useRedeemCouponMutation } from './hooks/useRedeemCouponMutation';

export default function CouponPage() {
    const { t } = useTranslation('coupon');
    const headingRef = usePageHeading(t('page.title'));
    const user = useSelector((state: ApplicationState) => state.auth.user);
    const mutation = useRedeemCouponMutation();

    const breadcrumbItems = useBreadcrumbItems([
        { title: t('breadcrumb.platform'), href: '#' },
        { title: t('breadcrumb.coupon') },
    ]);

    return (
        <div className="w-full min-h-full flex flex-col justify-start items-center gap-8">
            <div className="w-full flex flex-col justify-start items-start">
                <Breadcrumbs separatorMargin="xs" className="mb-6">
                    {breadcrumbItems}
                </Breadcrumbs>
                <div className="w-full flex flex-row justify-between items-end">
                    <div className="flex flex-col gap-1">
                        <h1 ref={headingRef} tabIndex={-1} className="text-3xl font-bold">
                            {t('page.title')}
                        </h1>
                        <p className="w-auto max-w-135 text-base text-fg/68">
                            {t('page.description')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-col gap-4">
                <CouponEligibilityNotice user={user} />
                <DialogBox
                    label={t('form.title')}
                    description={t('form.description')}
                    classNames="p-0"
                >
                    <CouponRedeemForm
                        onSubmit={async (code) => {
                            await mutation.mutateAsync(code);
                        }}
                        isSubmitting={mutation.isPending}
                    />
                </DialogBox>
            </div>
        </div>
    );
}
